/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
} from '@angular/material/dialog';
import { BufferService } from '../../buffer.service';
import { MeasureService } from '../../../../../shared/services/measure.service';
import { AppConfigState } from '../../../../../../core/state/appConfig/app-config.state';
import { Store } from '@ngxs/store';
import { CreateBuffer } from '../../buffer.actions';
import { LoggerService } from '../../../../../shared/services/logger.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import {
    LayoutDirective,
    LayoutGapDirective,
    LayoutAlignDirective,
} from '@ngbracket/ngx-layout/flex';
import { MatButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'dash-gis-buffer-dialog',
    templateUrl: './buffer-dialog.component.html',
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        LayoutDirective,
        LayoutGapDirective,
        LayoutAlignDirective,
        MatButton,
        MatFormField,
        MatInput,
        MatCheckbox,
        MatDialogActions,
    ],
})
export class BufferDialogComponent implements OnInit {
    public bufferDistance: number;
    public selectWithin: boolean;

    constructor(
        public dialogRef: MatDialogRef<BufferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private logger: LoggerService,
        private bufferService: BufferService,
        private store: Store
    ) {}

    public ngOnInit() {}

    public createBuffer(bufferDistance, selectWithin) {
        if (bufferDistance) {
            const distanceInMeters = MeasureService.lengthFeetToMeters(bufferDistance);
            this.store.dispatch(new CreateBuffer(distanceInMeters, selectWithin));
            this.dialogRef.close();
        }
        return false;
    }

    public onCancel() {
        this.dialogRef.close(false);
    }

    get bufferRanges(): number[] {
        return this.store.selectSnapshot(AppConfigState.bufferRanges);
    }
}
